// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ScheduleOutlinedSvg from "@ant-design/icons-svg/es/asn/ScheduleOutlined";
import AntdIcon from '../components/AntdIcon';

var ScheduleOutlined = function ScheduleOutlined(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: ScheduleOutlinedSvg
  }));
};

ScheduleOutlined.displayName = 'ScheduleOutlined';
export default React.forwardRef(ScheduleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/ScheduleOutlined.js
// module id = 1757
// module chunks = 0